import { render, staticRenderFns } from "./BimMark.vue?vue&type=template&id=2dc6b718&scoped=true"
import script from "./BimMark.vue?vue&type=script&lang=js"
export * from "./BimMark.vue?vue&type=script&lang=js"
import style0 from "./BimMark.vue?vue&type=style&index=0&id=2dc6b718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6b718",
  null
  
)

export default component.exports